import Circuit from "~/components/circuit"

const json = [
  {
    name: "mixed3a",
    modules: [
      {
        name: "Angles",
        neurons: [116, 77, 176, 149, 100],
      },
    ],
  },
  {
    name: "mixed3b",
    modules: [
      {
        name: "Curve Detectors",
        neurons: [379, 406, 385, 343, 342, 388, 340, 330, 349, 324],
      },
    ],
  },
]

export default class AngleCircuit extends Component {
  render() {
    return (
      <Surface marginBottom={30} marginTop={-10}>
        <Circuit circuit={json} inlineLayerNames />
        <Text alignSelf="center" fontStyle="italic" marginTop={10}>
          Angles in 3a detect perpendicular lines to the curves of 3b. The
          angles of 3a that feed into the curves of 3b.
        </Text>
      </Surface>
    )
  }
}
